import { fetchWithAuth } from "./FetchHelper";

const apiUrl = process.env.REACT_APP_API_URL;
export const GetInteraccionsAyuda = async (id_user: string, id_aula: string) => {
    try {
        const response = await fetchWithAuth(`${apiUrl}:8061/usuaris/${id_user}/aules/${id_aula}/interaccions/ayuda`);
        if (response && response.ok) {
            const jsonData = await response.json();
            return jsonData;
        }
        return [];
    } catch (error) {
        console.log('Error al obtener los datos:', error);
        return [];
    }
};
